import Invoice from "../../models/domain/Invoice";

interface Props {
  invoices: Invoice[];
  totals: {
    billed: number;
    paid: number;
    balance: number;
  };
}

export function InvoiceTable({ invoices, totals }: Props) {
  return (
    <div className="card shadow-sm border-0">
      <div className="table-responsive">
        <table className="table align-middle mb-0">
          <thead className="table-light">
            <tr className="small text-uppercase text-muted">
              <th>Invoice #</th>
              <th>Patient Name</th>
              <th>Doctor</th>
              <th>Service</th>
              <th>Mode</th>
              <th>Status</th>
              <th className="text-end">Billed</th>
              <th className="text-end">Paid</th>
              <th className="text-end">Balance</th>
            </tr>
          </thead>

          <tbody>
            {invoices.map((inv) => (
              <tr key={inv.receipt_no}>
                <td className="fw-semibold text-danger">#{inv.receipt_no}</td>

                <td>{inv.patient_name}</td>

                <td>{inv.doctor_name}</td>

                <td>{inv.consult_description}</td>

                <td>{inv.payment_mode ?? "-"}</td>

                <td>
                  <span
                    className={`badge ${
                      inv.payment_status === "FULL"
                        ? "bg-success-subtle text-success"
                        : "bg-warning-subtle text-warning"
                    }`}
                  >
                    {inv.payment_status}
                  </span>
                </td>

                <td className="text-end">
                  ₹{inv.total_amount?.toLocaleString()}
                </td>

                <td className="text-end text-success">
                  ₹{inv.paid_amount?.toLocaleString()}
                </td>

                <td
                  className={`text-end fw-semibold ${
                    inv.pending_amount > 0 ? "text-danger" : ""
                  }`}
                >
                  ₹{inv.pending_amount?.toLocaleString()}
                </td>
              </tr>
            ))}

            {/* Totals Row */}
            <tr className="table-light fw-semibold">
              <td colSpan={6} className="text-end">
                TOTALS
              </td>
              <td className="text-end">₹{totals.billed?.toLocaleString()}</td>
              <td className="text-end text-info">
                ₹{totals.paid?.toLocaleString()}
              </td>
              <td className="text-end text-danger">
                ₹{totals.balance?.toLocaleString()}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
